export enum StatusRequisicao {
    AGUARDANDO = 'A',
    AGUARDANDO_FORNECEDOR = 'AF',
    ACEITA = 'F',
    ACEITA_PARCIALMENTO = 'P',
    ESTORNO = 'E',
    RECUSADO = 'R'
}
